const Loading = () => {
    return (
        <div className={`loading px--4 py--4`}>
            <div className="loading__container">
                <div className={"loading__container-item"}></div>
                <div className={"loading__container-item"}></div>
                <div className={"loading__container-item"}></div>
                <div className={"loading__container-item"}></div>
            </div>
        </div>
    )
}

export default Loading;
